import ConfirmationAnimation from './ConfirmationAnimation';

export default ConfirmationAnimation;
